// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--Ixzu+";
export var spinning = "styles-module--spinning--sl0j4";